import module from '../bahabot.module'

module.filter('bbDate', ['$filter', ($filter) => {
    return function(date, format, timezone, onNone = 'Never') {
        return !date ? onNone : $filter('date')(date, format, timezone)
    };
}])